module.exports = __webpack_public_path__ + "static/media/ptp01.7fb234fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/etp/ptp01.jpg
// module id = 403
// module chunks = 0